module.exports = __webpack_public_path__ + "static/media/sad-jar.780a3cea.png";